<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <!-- <a-form-item label="编号" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="保存时系统自动生成"
              disabled
              v-decorator="[
          'id',
          {rules: [{ required: false, message: '请输入编号!' }],initialValue:info.id}
        ]"
            ></a-input>
          </a-form-item>-->
          <a-form-item label="名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入名称"
              v-decorator="[
          'itemName',
          {rules: [{ required: true, message: '请输入名称!' }],initialValue:info.itemName}
        ]"
            ></a-input>
          </a-form-item>

          <a-form-item
            label="父级"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 19 }"
            v-if="dinfo.type==2"
          >
            {{areaInfo.text}}
            <a-cascader
              :options="areaData"
              :fieldNames="{ label: 'itemName', value: 'id', children: 'children' }"
              @change="onChange"
              changeOnSelect
            >
              <a-button type="primary" icon="search" style="margin-left:10px">选择</a-button>
              <!-- <a href="#">选择</a> -->
            </a-cascader>
          </a-form-item>

          <a-form-item label="字典项值" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入字典项值"
              v-decorator="[
          'itemValue',
          {rules: [{ required: true, message: '请输入字典项值!' }],initialValue:info.itemValue}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="排序" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入排序"
              v-decorator="[
          'orderno',
          {rules: [{ required: true, message: '请输入排序!' }],initialValue:info.orderno}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="图片" :label-col="{ span:4  }" :wrapper-col="{ span: 19 }">
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :fileList="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>

          <a-form-item
            label="前台显示"
            :label-col="{ span: 4 }"
            v-if="dinfo.type==4"
            :wrapper-col="{ span: 19 }"
          >
            <a-switch
              v-model="info.isShow"
              v-decorator="[
          'isShow',
          {rules: []}
        ]"
            />
          </a-form-item>
          <!-- <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-textarea
              placeholder="请输入备注"
              :rows="4"
              v-decorator="[
          'description',
          {rules: [{ required: false, message: '请输入备注!' }],initialValue:info.description}
        ]"
            />
          </a-form-item>-->
          <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;

var areaOptions = [
  {
    value: "0",
    label: "根目录",
    children: []
  }
];

export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    },
    dinfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        orderno: 0,
        parentId: 0,
        isShow: true
      },
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: [],
      areaData: [
        {
          id: "0",
          itemName: "根目录",
          children: []
        }
      ],
      areaInfo: {
        text: "根目录",
        id: 0
      },
      // fileList: [],
      // previewImage: "",
      // picArr: [],
    };
  },
  components: {},
  mounted() {
    this.$nextTick(function() {
      that = this;
      console.log("zi", this.infos);
      console.log("zi", this.dinfo);
      if (this.infos.id) {
        //编辑
        this.getInfo();
      }
      this.GetTree();
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    /**获取详情 */
    getInfo() {
      this.isloading = true;
      this.$api.dictionaryItem
        .getById(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            if (this.dinfo.type == 2) {
              this.areaInfo.text =
                res.data.parentId == 0 ? "根目录" : res.data.parentName;
              this.areaInfo.id = res.data.parentId;
            }

            if (this.dinfo.type == 4) {
              this.info.isShow = this.$commen.changeIntBoolean(res.data.isShow);
            }

            if(res.data.picture.length>0) {
              var pics = res.data.picture.split(",");
              for (var i = 0; i < pics.length; i++) {
                this.fileList.push({
                  uid: i,
                  name: "图片" + (i + 1) + ".png",
                  status: "done",
                  url: pics[i]
                });
              }
            }


          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    GetTree() {
      //获取列表
      this.isloading = true;
      this.$api.dictionaryItem
        .tree(this.dinfo.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            // this.list.datas = res.data;
            this.areaData[0].children = res.data;
            console.log("tree1", res.data);
            console.log("tree", this.areaData);
            // this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      // this.uploadImg = [];
      // this.fileList.forEach(function(item, index) {
      //   that.uploadImg.push(item.response.data.path);
      // });
      this.picArr=[];
      for(var i=0;i<this.fileList.length;i++) {
        if (this.fileList[i].url) {
          this.picArr.push(this.fileList[i].url);
        } else {
          this.picArr.push(this.fileList[i].response.data.path);
        }
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.infos.id) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.dictionaryItem
              .update(
                this.infos.id,
                this.dinfo.id,
                values.itemName,
                values.orderno,
                values.itemValue,
                this.info.parentId,
                values.isShow
                  ? this.$commen.changeBooleanInt(values.isShow)
                  : this.$commen.changeBooleanInt(this.info.isShow),
                this.picArr?this.picArr.join(','):'',
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //添加
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.dictionaryItem
              .save(
                this.dinfo.id,
                values.itemName,
                values.orderno,
                values.itemValue,
                this.info.parentId,
                values.isShow
                  ? this.$commen.changeBooleanInt(values.isShow)
                  : this.$commen.changeBooleanInt(this.info.isShow),
                this.picArr?this.picArr.join(','):'',
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },
    onChange(value, selectedOptions) {
      console.log(value, selectedOptions);
      if (this.infos.id) {
        if (this.infos.id == selectedOptions[selectedOptions.length - 1].id) {
          this.$message.error("不能选择自己作为父级");
          return false;
        }
      }
      //this.text = selectedOptions.map(o => o.itemName).join(', ');
      this.areaInfo.text = selectedOptions[selectedOptions.length - 1].itemName;
      this.areaInfo.id = selectedOptions[selectedOptions.length - 1].id;
      this.info.parentId = this.areaInfo.id;
      //console.log(date, dateString);
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
        this.fileList = info.fileList;
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
</style>